import { standardStringSchema, trimmedStringSchema } from "@/schemas"
import { z } from "zod"

export const editMeterSchema = z.object({
  code: standardStringSchema.min(1),
  siteId: trimmedStringSchema.min(1),
  provider: standardStringSchema.min(1),
  accountNumber: standardStringSchema.optional().default(""),
})

export type EditMeterSchema = z.infer<typeof editMeterSchema>
